import type React from 'react';

import { toast } from 'react-toastify';

import { EditPermissions } from '@vlabs/monokit/entities/permissions/edit-permissions';
import type { PointPermissions } from '@vlabs/monokit/entities/permissions/edit-permissions/types';
import { useGetUser, useGetRole, usePatchRole } from '@vlabs/api/artemy/client';
import type { UserId } from '@vlabs/api/artemy/model';

import { useUserPermissionsTranslation } from './i18n';

interface UserPermissionsProps {
  userId: UserId;
}

function UserPermissions({
  userId,
}: UserPermissionsProps): React.JSX.Element {
  const { t } = useUserPermissionsTranslation();

  const { data: user } = useGetUser(userId);
  const { data: role } = useGetRole(user?.role_id ?? '', {
    query: {
      enabled: !!user?.role_id,
    },
  });

  const patchRole = usePatchRole({
    mutation: {
      onSuccess: () => {
        toast.success(t('toast_success'));
      },
      onError: () => {
        toast.error(t('toast_error'));
      },
    },
  });

  const handleClick = (permissions: PointPermissions) => {
    if (!role?.role_id) return;

    patchRole.mutate({
      roleId: role.role_id,
      data: { permissions },
    });
  };

  return (
    <EditPermissions
      defaultValues={role?.permissions as PointPermissions}
      disabled
      onSubmit={handleClick}
      roleType={user?.is_system ? 'system' : 'custom'}
    />
  );
}

export { UserPermissions };
